export const category = [
    {
        id: 'grocery',
        name: 'Grocery',
        type: 'primary_category',
        data: [
            {
                id: "vegetables-fruits",
                name: "Vegetables & Fruits",
                type: "sub-category",
                data: [
                    {
                        id: "fresh-vegetables",
                        name: "Fresh Vegetables",
                        type: "product-group",
                        data: [
                            "potato",
                            "onion",
                            "tomato",
                            "leafy-vegetables",
                            "root-vegetables",
                            "gourds",
                            "beans-peas",
                            "cabbage-cauliflower",
                            "exotic-vegetables",
                            "mushrooms",
                            "raw-banana",
                            "chilli-peppers",
                            "jackfruit",
                            "garlic",
                            "brinjal",
                            "seasonal-vegetables"
                        ]
                    },
                    {
                        id: "fresh-fruits",
                        name: "Fresh Fruits",
                        type: "product-group",
                        data: [
                            "banana",
                            "apple",
                            "mango",
                            "citrus-fruits",
                            "grapes",
                            "pomegranate",
                            "seasonal-fruits",
                            "cut-fruits",
                            "coconut"
                        ]
                    }
                ]
            },
            {
                id: "atta-besan-sooji",
                name: "Atta, Besan & Sooji",
                type: "sub-category",
                data: [
                    {
                        id: "atta",
                        name: "Atta",
                        type: "product-group",
                        data: [
                            "whole-wheat-atta",
                            "multigrain-atta",
                            "chakki-atta",
                            "organic-atta"
                        ]
                    },
                    {
                        id: "sooji-maida-daliya",
                        name: "Sooji, Maida & Daliya",
                        type: "product-group",
                        data: [
                            "sooji", "maida", "daliya", "rava", "semolina", "broken-wheat"
                        ]
                    },
                    {
                        id: "sattu-besan",
                        name: "Sattu & Besan",
                        type: "product-group",
                        data: [
                            "gram-flour",
                            "sattu",
                            "roasted-besan"
                        ]
                    },
                    {
                        id: "millets-flours",
                        name: "Millets & Other Flours",
                        type: "product-group",
                        data: [
                            "ragi-flour",
                            "jowar-flour",
                            "bajra-flour",
                            "rice-flour",
                            "corn-flour",
                            "oats-flour"
                        ]
                    }
                ]
            },
            {
                id: "oils-ghee",
                name: "Oils & Ghee",
                type: "sub-category",
                data: [
                    {
                        id: "ghee-vanaspati",
                        name: "Ghee",
                        type: "product-group",
                        data: [
                            "vanaspati-ghee",
                            "cow-ghee",
                            "buffalo-ghee",
                            "organic-ghee"
                        ]
                    },
                    {
                        id: "mustard-oil",
                        name: "Mustard Oil",
                        type: "product-group",
                        data: [
                            "mustard-oil",
                        ]
                    },
                    {
                        id: "soyabean-sunflower-oil",
                        name: "Soyabean & Sunflower Oil",
                        type: "product-group",
                        data: [
                            "sunflower-oil",
                            "soyabean-oil"
                        ]
                    },
                    {
                        id: "rice-bran",
                        name: "Rice Bran",
                        type: "product-group",
                        data: [
                            "rice-bran-oil"
                        ]
                    },
                    {
                        id: "groundnut-other-oils",
                        name: "Groundnut & Other Oils",
                        type: "product-group",
                        data: [
                            "groundnut-oil",
                            "olive-oil",
                            "coconut-oil-edible",
                            "blended-oil",
                            "palmolein-oil"
                        ]
                    }
                ]
            },
            {
                id: "pulses",
                name: "Pulses",
                type: "sub-category",
                data: [
                    {
                        id: "arhar-toor-dal",
                        name: "Arhar & Toor Dal",
                        type: "product-group",
                        data: [
                            "toor-dal",
                            "arhar-dal"
                        ]
                    },
                    {
                        id: "masoor-moong-dal",
                        name: "Masoor & Moong Dal",
                        type: "product-group",
                        data: [
                            "moong-dal",
                            "masoor-dal",
                            "green-moong"
                        ]
                    },
                    {
                        id: "rajma-chola-matar",
                        name: "Rajma, Chola & Matar",
                        type: "product-group",
                        data: [
                            "rajma",
                            "white-peas",
                            "yellow-peas"
                        ]
                    },
                    {
                        id: "kala-chana-chana-dal",
                        name: "Kala Chana & Chana Dal",
                        type: "product-group",
                        data: [
                            "kabuli-chana",
                            "kala-chana",
                            "chana-dal"
                        ]
                    },
                    {
                        id: "other-pulses",
                        name: "Other Pulses",
                        type: "product-group",
                        data: [
                            "urad-dal",
                            "mix-dal",
                            "green-moong",
                        ]
                    },
                ]
            },
            {
                id: "cereals-rice",
                name: "Cereals & Rice",
                type: "sub-category",
                data: [
                    {
                        id: "basmati-rice",
                        name: "Basmati Rice",
                        type: "product-group",
                        data: [
                            "long-grain-basmati",
                            "extra-long-basmati",
                            "brown-basmati",
                            "organic-basmati"
                        ]
                    },
                    {
                        id: "raw-boiled-rice",
                        name: "Raw & Boiled Rice",
                        type: "product-group",
                        data: [
                            "sona-masoori",
                            "kolam-rice",
                            "idli-rice",
                            "parboiled-rice",
                            "brown-rice",
                            "katarni-rice"
                        ]
                    },
                    {
                        id: "sabudana-other-cereals",
                        name: "Sabudana & Other Cereals",
                        type: "product-group",
                        data: [
                            "poha",
                            "sabudana",
                            "corn-kernels",
                            "barley",
                            "quinoa",
                            "soya-chunks",
                            "soya-granules"
                        ]
                    },
                ]
            },
            {
                id: "dry-fruits-nuts",
                name: "Dry Fruits & Nuts",
                type: "sub-category",
                data: [
                    {
                        id: "almond-cashew",
                        name: "Almonds & Cashews",
                        type: "product-group",
                        data: [
                            "whole-cashew",
                            "broken-cashew",
                            "roasted-cashew",
                            "california-almond",
                            "mamra-almond",
                            "roasted-almond"
                        ]
                    },
                    {
                        id: "pista-akhrot",
                        name: "Pista & Akhrot",
                        type: "product-group",
                        data: [
                            "salted-pista",
                            "unsalted-pista",
                            "california-walnut",
                            "walnut-kernels"
                        ]
                    },
                    {
                        id: "dates-seeds",
                        name: "Dates & Seeds",
                        type: "product-group",
                        data: [
                            "arabian-dates",
                            "seedless-dates",
                            "medjool-dates",
                            "kimia-dates",
                            "flax-seeds",
                            "chia-seeds",
                            "pumpkin-seeds",
                            "sunflower-seeds"
                        ]
                    },
                    {
                        id: "raisins",
                        name: "Raisins",
                        type: "product-group",
                        data: [
                            "golden-raisin",
                            "black-raisin"
                        ]
                    },
                    {
                        id: "nuts-makhana",
                        name: "Nuts & Makhana",
                        type: "product-group",
                        data: [
                            "raw-peanut",
                            "white-peanut",
                            "roasted-makhana"
                        ]
                    },
                ]
            },
            {
                id: "salt-sugar-jaggery",
                name: "Salt, Sugar & Jaggery",
                type: "sub-category",
                data: [
                    {
                        id: "salt",
                        name: "Salt",
                        type: "product-group",
                        data: [
                            "iodized-salt",
                            "rock-salt",
                            "sea-salt",
                            "pink-salt",
                            "low-sodium-salt"
                        ]
                    },
                    {
                        id: "sugar",
                        name: "Sugar",
                        type: "product-group",
                        data: [
                            "white-sugar",
                            "brown-sugar",
                            "powdered-sugar",
                        ]
                    },
                    {
                        id: "jaggery",
                        name: "Jaggery",
                        type: "product-group",
                        data: [
                            "solid-jaggery",
                            "powder-jaggery",
                            "liquid-jaggery"
                        ]
                    },
                    {
                        id: "other-sweeteners",
                        name: "Other Sweeteners",
                        type: "product-group",
                        data: [
                            "sugar-substitute",
                            "mishri"
                        ]
                    }
                ]
            },
            {
                id: "masala-spices",
                name: "Masala & Spices",
                type: "sub-category",
                data: [
                    {
                        id: "whole-spices",
                        name: "Whole Spices",
                        type: "product-group",
                        data: [
                            "cumin-seeds",
                            "mustard-seeds",
                            "cloves",
                            "cardamom",
                            "black-pepper",
                            "fenugreek-seeds",
                            "tamarind",
                            "fennel-seeds",
                            "cinnamon",
                            "ajwain",
                            "mangrela",
                            "coriander-seeds",
                            "whole-garam-masala",
                            "star-anise",
                            "tej-patta",
                            "dry-red-chilli"
                        ]
                    },
                    {
                        id: "powdered-spices",
                        name: "Powdered Spices",
                        type: "product-group",
                        data: [
                            "turmeric-powder",
                            "chilli-powder",
                            "coriander-powder",
                            "garam-masala",
                            "hing",
                        ]
                    },
                    {
                        id: "blended-spices",
                        name: "Blended Spices",
                        type: "product-group",
                        data: [
                            "paneer-masala",
                            "biryani-masala",
                            "chicken-masala",
                            "sambar-powder",
                            "other-masala",
                            "panch-phoron",
                            "kasuri-methi",
                            "masala-sprinkles",
                            "sabji-masala",
                            "kitchen-king-masala"
                        ]
                    },
                    {   // added recently
                        id: "cooking-pastes",
                        name: "Cooking Pastes",
                        type: "product-group",
                        data: [
                            "ginger-garlic-paste",
                            "green-chilli-paste",
                            "tamarind-paste",
                            "onion-tomato-paste",
                            "curry-paste",
                            "garam-masala-paste",
                            "other-cooking-paste",
                            "garlic-paste",
                            "ginger-paste",
                            "schezwan-paste"
                        ]
                    },
                    {   // added recently
                        id: "herbs-seasonings",
                        name: "Herbs & Seasonings",
                        type: "product-group",
                        data: [
                            "fresh-coriander",
                            "fresh-parsley",
                            "fresh-mint"
                        ]
                    }
                ]
            },
            {
                id: "pickles-papad",
                name: "Pickles & Papad",
                type: "sub-category",
                data: [
                    {
                        id: "pickles-chutney",
                        name: "Pickles & Chutney",
                        type: "product-group",
                        data: [
                            "mango-pickle",
                            "lime-pickle",
                            "mixed-pickle",
                            "garlic-pickle",
                            "ginger-garlic-paste",
                            "green-chilli-paste",
                            "tamarind-paste",
                            "onion-tomato-paste",
                            "schezwan-paste"
                        ]
                    },
                    {   // added recently
                        id: "cooking-pastes",
                        name: "Cooking Pastes",
                        type: "product-group",
                        data: [
                            "ginger-garlic-paste",
                            "green-chilli-paste",
                            "tamarind-paste",
                            "onion-tomato-paste",
                            "curry-paste",
                            "garam-masala-paste",
                            "other-cooking-paste",
                            "garlic-paste",
                            "ginger-paste",
                            "schezwan-paste"
                        ]
                    },
                    {
                        id: "papad-fryums",
                        name: "Papad & Fryums",
                        type: "product-group",
                        data: [
                            "urad-papad",
                            "moong-papad",
                            "rice-papad",
                            "wheel-fryums",
                            "tube-fryums",
                            "animal-shape-fryums",
                        ]
                    },

                ]
            },

        ]
    },
    {
        id: "dairy-breakfast",
        name: "Dairy & Breakfast",
        type: "category",
        data: [
            {
                id: "milk-dairy",
                name: "Milk & Dairy",
                type: "sub-category",
                data: [
                    {
                        id: "milk-curd",
                        name: "Milk & Curd",
                        type: "product-group",
                        data: [
                            "full-cream-milk",
                            "toned-milk",
                            "double-toned-milk",
                            "skimmed-milk",
                            "organic-milk",
                            "flavoured-milk",
                            "plain-curd",
                            "greek-yogurt",
                            "probiotic-yogurt",
                            "flavoured-yogurt"
                        ]
                    },
                    {
                        id: "paneer-cream",
                        name: "Paneer & Cream",
                        type: "product-group",
                        data: [
                            "fresh-paneer",
                            "malai-paneer",
                            "low-fat-paneer",
                            "organic-paneer",
                            "fresh-cream",
                            "whipping-cream",
                            "malai",
                        ]
                    },
                    {
                        id: "butter-cheese",
                        name: "Butter & Cheese",
                        type: "product-group",
                        data: [
                            "salted-butter",
                            "unsalted-butter",
                            "white-butter",
                            "processed-cheese",
                            "cheddar-cheese",
                            "mozzarella-cheese",
                            "cheese-slices",
                            "cheese-spread"
                        ]
                    },
                    {
                        id: "lassi-buttermilk-milkshakes",
                        name: "Lassi, Buttermilk & Milkshakes",
                        type: "product-group",
                        data: [
                            "sweet-lassi",
                            "salted-lassi",
                            "buttermilk",
                            "flavoured-lassi",
                        ]
                    },
                    {
                        id: "eggs-mushroom",
                        name: "Eggs & Mushroom",
                        type: "product-group",
                        data: [
                            "mushrooms",
                            "white-eggs",
                            "brown-eggs",
                            "organic-eggs"
                        ]
                    },
                    {
                        id: "other-milk-products",
                        name: "Other Milk Products",
                        type: "product-group",
                        data: [
                            "milk-powder"
                        ]
                    },
                ]
            },
            {
                id: "breads-buns-more",
                name: "Bread, Buns & More",
                type: "sub-category",
                data: [
                    {
                        id: "breads-buns",
                        name: "Breads & Buns",
                        type: "product-group",
                        data: [
                            "white-bread",
                            "brown-bread",
                            "multigrain-bread",
                            "whole-wheat-bread",
                            "sandwich-bread",
                            "burger-bun",
                            "pav-bun",
                            "hotdog-bun"
                        ]
                    },
                    {
                        id: "cakes-cream-roll-pies",
                        name: "Cakes, Rolls & More",
                        type: "product-group",
                        data: [
                            "cream-roll",
                            "sponge-cake",
                            "cup-cake",
                            "fruit-cake",
                            "croissant",
                            "chocolate-cake",
                            "cream-pie"
                        ]
                    }
                ]
            },
            {
                id: "breakfast-cereals",
                name: "Breakfast & Cereals",
                type: "sub-category",
                data: [
                    {
                        id: "oats",
                        name: "Oats",
                        type: "product-group",
                        data: [
                            "rolled-oats",
                            "instant-oats",
                            "steel-cut-oats",
                            "flavoured-oats"
                        ]
                    },
                    {
                        id: "cornflakes-muesli",
                        name: "Cornflakes & Muesli",
                        type: "product-group",
                        data: [
                            "plain-cornflakes",
                            "honey-cornflakes",
                            "muesli",
                            "granola",
                            "flavoured-cereal"
                        ]
                    },
                    {
                        id: "instant-breakfast",
                        name: "Instant Breakfast",
                        type: "product-group",
                        data: [
                            "poha-mix",
                            "upma-mix",
                            "idli-mix",
                            "dosa-mix"
                        ]
                    },
                    {
                        id: "rusk-khari-wafers",
                        name: "Rusk, Khari & Wafers",
                        type: "product-group",
                        data: [
                            "milk-rusk",
                            "elaichi-rusk",
                            "khari-biscuit",
                            "cream-wafer",
                            "plain-rusk"
                        ]
                    },
                    {
                        id: "baking-essentials",
                        name: "Baking Essentials",
                        type: "product-group",
                        data: [
                        ]
                    }
                ]
            },
            {
                id: "jams-spreads",
                name: "Jams & Spreads",
                type: "sub-category",
                data: [
                    {
                        id: "jams",
                        name: "Jams",
                        type: "product-group",
                        data: [
                            "mixed-fruit-jam",
                            "strawberry-jam",
                            "mango-jam"
                        ]
                    },
                    {
                        id: "honey",
                        name: "Honey",
                        type: "product-group",
                        data: [
                            "raw-honey",
                            "organic-honey",
                            "multiflora-honey"
                        ]
                    },
                    {
                        id: "peanut-butter",
                        name: "Peanut Butter",
                        type: "product-group",
                        data: [
                            "creamy-peanut-butter",
                            "crunchy-peanut-butter",
                            "natural-peanut-butter"
                        ]
                    },
                    {
                        id: "mayonnaise",
                        name: "Mayonnaise",
                        type: "product-group",
                        data: [
                            "eggless-mayo",
                            "garlic-mayo",
                            "cheese-mayo"
                        ]
                    },
                    {
                        id: "syrup-pre-mixes",
                        name: "Syrup & Pre-Mixes",
                        type: "product-group",
                        data: [
                            "chocolate-syrup",
                            "strawberry-syrup",
                            "lemonade-premix",
                            "fruit-syrup",
                            "herbal-concentrate",
                            "flavoured-syrup",
                            "sharbat-concentrate"
                        ]
                    }
                ]
            }

        ]
    },
    {
        id: "snacks-drinks",
        name: "Snacks & Drinks",
        type: "category",
        data: [
            {
                id: "chips-namkeen",
                name: "Chips & Namkeen",
                type: "sub-category",
                data: [
                    {
                        id: "chips-nachos",
                        name: "Chips & Nachos",
                        type: "product-group",
                        data: [
                            "potato-chips",
                            "banana-chips",
                            "tortilla-nachos",
                            "multigrain-chips",
                            "baked-chips",
                            "nachos"
                        ]
                    },
                    {
                        id: "bhujia-mixtures",
                        name: "Bhujia & Mixtures",
                        type: "product-group",
                        data: [
                            "aloo-bhujia",
                            "besan-bhujia",
                            "navratan-mixture",
                            "bombay-mixture",
                            "extruded-snacks",
                            "sev-bhujia",
                            "salted-peanuts",
                            "boondi",
                            "murukku",
                            "mini-samosa",
                            "chanachur",
                            "khatta-meetha-mixture",
                            "moong-dal-namkeen",
                            "punjabi-tadka-mixture",
                            "roasted-makhana"
                        ]
                    },
                    {
                        id: "namkeen-snacks",
                        name: "Namkeen Snacks",
                        type: "product-group",
                        data: [
                            "sev",
                            "chakli",
                            "mathri",
                            "kachori-snack",
                            "bhel",
                        ]
                    },
                    {
                        id: "popcorn",
                        name: "Popcorn",
                        type: "product-group",
                        data: [
                            "butter-popcorn",
                            "caramel-popcorn",
                            "cheese-popcorn",
                            "microwave-popcorn"
                        ]
                    }
                ]
            },
            {
                id: "biscuits-cookies",
                name: "Biscuits & Cookies",
                type: "sub-category",
                data: [
                    {
                        id: "marie-digestive",
                        name: "Marie & Digestive",
                        type: "product-group",
                        data: [
                            "marie-biscuit",
                            "digestive-biscuit",
                            "sugar-free-digestive"
                        ]
                    },
                    {
                        id: "cream-biscuits",
                        name: "Cream Biscuits",
                        type: "product-group",
                        data: [
                            "chocolate-cream",
                            "vanilla-cream",
                            "strawberry-cream",
                            "milk-cream",
                            "jam-cream"
                        ]
                    },
                    {
                        id: "cookies",
                        name: "Cookies",
                        type: "product-group",
                        data: [
                            "choco-chip",
                            "butter-cookie",
                            "oat-cookie",
                            "dry-fruit-cookie"
                        ]
                    },
                    {
                        id: "glucose-milk-biscuits",
                        name: "Glucose & Milk Biscuits",
                        type: "product-group",
                        data: [
                            "glucose-biscuit",
                            "milk-biscuit",
                            "butter-biscuit"
                        ]
                    },
                    {
                        id: "sweet-salty-biscuits",
                        name: "Sweet & Salty Biscuits",
                        type: "product-group",
                        data: [
                            "salted-biscuit",
                            "sweet-biscuit",
                            "cracker-biscuit"
                        ]
                    },
                    {
                        id: "rusk-khari-wafers",
                        name: "Rusk, Khari & Wafers",
                        type: "product-group",
                        data: [
                            "milk-rusk",
                            "elaichi-rusk",
                            "khari-biscuit",
                            "cream-wafer",
                            "plain-rusk"
                        ]
                    }
                ]
            },
            {
                id: "noodles-instant-food",
                name: "Noodles & Instant Food",
                type: "sub-category",
                data: [
                    {
                        id: "noodles",
                        name: "Noodles",
                        type: "product-group",
                        data: [
                            "masala-noodles",
                            "chicken-noodles",
                            "veg-noodles",
                            "cup-noodles"
                        ]
                    },
                    {
                        id: "pasta",
                        name: "Pasta",
                        type: "product-group",
                        data: [
                            "macaroni",
                            "penne",
                            "fusilli"
                        ]
                    },
                    {
                        id: "vermicelli",
                        name: "Vermicelli",
                        type: "product-group",
                        data: [
                            "plain-vermicelli",
                            "roasted-vermicelli"
                        ]
                    },
                    {
                        id: "soup",
                        name: "Soup",
                        type: "product-group",
                        data: [
                            "tomato-soup",
                            "sweet-corn-soup",
                            "hot-sour-soup"
                        ]
                    },
                    {
                        id: "instant-mix",
                        name: "Instant Mix",
                        type: "product-group",
                        data: [
                            "poha-mix",
                            "upma-mix",
                            "gulab-jamun-mix"
                        ]
                    },
                    {
                        id: "ready-to-eat",
                        name: "Ready to Eat",
                        type: "product-group",
                        data: [
                            "dal-makhani-rte",
                            "rajma-rice-rte"
                        ]
                    }
                ]
            },
            {
                id: "sauces-dips",
                name: "Sauces & Dips",
                type: "sub-category",
                data: [
                    {
                        id: "tomato-ketchup",
                        name: "Tomato Ketchup",
                        type: "product-group",
                        data: [
                            "classic-ketchup",
                            "no-onion-no-garlic-ketchup",
                            "organic-ketchup"
                        ]
                    },
                    {
                        id: "mayonnaise",
                        name: "Mayonnaise",
                        type: "product-group",
                        data: [
                            "eggless-mayo",
                            "garlic-mayo",
                            "cheese-mayo"
                        ]
                    },
                    {
                        id: "peanut-butter",
                        name: "Peanut Butter",
                        type: "product-group",
                        data: [
                            "crunchy-peanut-butter",
                            "smooth-peanut-butter",
                            "sugar-free-peanut-butter"
                        ]
                    },
                    {
                        id: "syrup-pre-mixes",
                        name: "Syrup & Pre Mixes",
                        type: "product-group",
                        data: [
                            "chocolate-syrup",
                            "strawberry-syrup",
                            "lemonade-premix"
                        ]
                    },
                    {
                        id: "chinese-sauces",
                        name: "Chinese Sauces",
                        type: "product-group",
                        data: [
                            "soy-sauce",
                            "chilli-sauce",
                            "schezwan-sauce"
                        ]
                    },
                    {
                        id: "dips-salad-dressings",
                        name: "Dips & Salad Dressings",
                        type: "product-group",
                        data: [
                            "cheese-dip",
                            "mint-dip",
                            "vinaigrette-dressing"
                        ]
                    }
                ]
            },
            {
                id: "chocolates-sweets",
                name: "Chocolates & Sweets",
                type: "sub-category",
                data: [
                    {
                        id: "chocolate",
                        name: "Chocolate",
                        type: "product-group",
                        data: [
                            "milk-chocolate",
                            "dark-chocolate",
                            "white-chocolate",
                            "wafer-chocolate",
                            "caramel-chocolate"
                        ]
                    },
                    {
                        id: "cakes-pies",
                        name: "Cakes & Pies",
                        type: "product-group",
                        data: [
                            "chocolate-cake",
                            "fruit-cake",
                            "cream-pie"
                        ]
                    },
                    {
                        id: "indian-mithai",
                        name: "Indian Mithai",
                        type: "product-group",
                        data: [
                            "gulab-jamun",
                            "rasgulla",
                            "kaju-katli"
                        ]
                    },
                    {
                        id: "dessert-mixes",
                        name: "Dessert Mixes",
                        type: "product-group",
                        data: [
                            "gulab-jamun-mix",
                            "rasmalai-mix"
                        ]
                    },
                    {
                        id: "candies-gums",
                        name: "Candies & Gums",
                        type: "product-group",
                        data: [
                            "hard-candy",
                            "chewing-gum",
                            "lollipop"
                        ]
                    },
                    {
                        id: "mint-mouth-freshners",
                        name: "Mint & Mouth Freshners",
                        type: "product-group",
                        data: [
                            "mint-candy",
                            "saunf-mix"
                        ]
                    }
                ]
            },
            {
                id: "drinks-juices",
                name: "Drinks & Juices",
                type: "sub-category",
                data: [
                    {
                        id: "cold-drinks",
                        name: "Cold Drinks",
                        type: "product-group",
                        data: [
                            "cola",
                            "lemon-soft-drink",
                            "orange-soft-drink",
                            "jeera-soft-drink"
                        ]
                    },
                    {
                        id: "fruit-juices",
                        name: "Fruits Juices",
                        type: "product-group",
                        data: [
                            "mango-juice",
                            "apple-juice",
                            "mixed-fruit-juice",
                            "pomegranate-juice"
                        ]
                    },
                    {
                        id: "energy-drinks",
                        name: "Energy Drinks",
                        type: "product-group",
                        data: [
                            "regular-energy-drink",
                            "sugar-free-energy-drink"
                        ]
                    },
                    {
                        id: "water-soda",
                        name: "Water & Soda",
                        type: "product-group",
                        data: [
                            "mineral-water",
                            "sparkling-water",
                            "soda"
                        ]
                    },
                    {
                        id: "lassi-buttermilk-milkshakes",
                        name: "Lassi, Buttermilk & Milkshakes",
                        type: "product-group",
                        data: [
                            "sweet-lassi",
                            "salted-buttermilk",
                            "chocolate-milkshake",
                            "vanilla-milkshake"
                        ]
                    },
                    {
                        id: "syrup-pre-mixes",
                        name: "Syrup & Pre-Mixes",
                        type: "product-group",
                        data: [
                            "chocolate-syrup",
                            "strawberry-syrup",
                            "lemonade-premix",
                            "fruit-syrup",
                            "herbal-concentrate",
                            "flavoured-syrup",
                            "sharbat-concentrate"
                        ]
                    }
                ]
            },
            {
                id: "tea-coffee-milk-drinks",
                name: "Tea, Coffee & Milk Drinks",
                type: "sub-category",
                data: [
                    {
                        id: "leaf-dust-tea",
                        name: "Leaf & Dust Tea",
                        type: "product-group",
                        data: [
                            "assam-tea",
                            "darjeeling-tea",
                            "regular-black-tea"
                        ]
                    },
                    {
                        id: "coffee",
                        name: "Coffee",
                        type: "product-group",
                        data: [
                            "instant-coffee",
                            "filter-coffee"
                        ]
                    },
                    {
                        id: "milk-health-drinks",
                        name: "Milk & Health Drinks",
                        type: "product-group",
                        data: [
                            "flavoured-milk",
                            "health-malt-drink",
                            "milk-powder"
                        ]
                    },
                    {
                        id: "green-flavoured-tea",
                        name: "Green & Flavoured Tea",
                        type: "product-group",
                        data: [
                            "green-tea",
                            "lemon-green-tea"
                        ]
                    }
                ]
            },
            {
                id: "ice-creams-frozen-food",
                name: "Ice Creams & Frozen Food",
                type: "sub-category",
                data: [
                    {
                        id: "frozen-foods",
                        name: "Frozen Foods",
                        type: "product-group",
                        data: [
                            "frozen-peas",
                            "frozen-fries"
                        ]
                    },
                    {
                        id: "tubs",
                        name: "Tubs",
                        type: "product-group",
                        data: [
                            "family-pack-vanilla",
                            "family-pack-chocolate"
                        ]
                    },
                    {
                        id: "sticks",
                        name: "Sticks",
                        type: "product-group",
                        data: [
                            "choco-stick",
                            "kulfi-stick"
                        ]
                    },
                    {
                        id: "cones",
                        name: "Cones",
                        type: "product-group",
                        data: [
                            "chocolate-cone",
                            "vanilla-cone"
                        ]
                    },
                    {
                        id: "cassata-sandwich",
                        name: "Cassata & Sandwich",
                        type: "product-group",
                        data: [
                            "cassata",
                            "ice-cream-sandwich"
                        ]
                    },
                    {
                        id: "single-serve-cups",
                        name: "Single Serve Cups",
                        type: "product-group",
                        data: [
                            "single-serve-vanilla"
                        ]
                    },
                    {
                        id: "cakes-others",
                        name: "Cakes & Others",
                        type: "product-group",
                        data: [
                            "ice-cream-cake"
                        ]
                    }
                ]
            }
        ]
    },
    {
        id: 'beauty-personal-care',
        name: 'Beauty & Personal Care',
        type: 'category',
        data: [
            {
                id: "soaps-body-washes",
                name: "Soaps & Body Washes",
                type: "sub-category",
                data: [

                    {
                        id: "soaps",
                        name: "Soaps",
                        type: "product-group",
                        data: [
                            "bathing-soap",
                            "herbal-soap",
                            "medicated-soap",
                            "moisturizing-soap",
                            "glycerin-soap"
                        ]
                    },

                    {
                        id: "shower-gel",
                        name: "Shower Gel",
                        type: "product-group",
                        data: [
                            "moisturizing-body-wash",
                            "refreshing-body-wash",
                            "ayurvedic-body-wash"
                        ]
                    },

                    {
                        id: "handwash-sanitisers",
                        name: "Handwash & Sanitisers",
                        type: "product-group",
                        data: [
                            "liquid-handwash",
                            "foaming-handwash",
                            "alcohol-sanitiser",
                            "gel-sanitiser"
                        ]
                    },

                    {
                        id: "bathing-accessories",
                        name: "Bathing Accessories",
                        type: "product-group",
                        data: [
                            "loofah",
                            "bath-brush",
                            "body-scrubber"
                        ]
                    }

                ]
            },
            {
                id: "skin-face-care",
                name: "Skin & Face Care",
                type: "sub-category",
                data: [

                    {
                        id: "face-wash-cleanser",
                        name: "Face Wash & Cleanser",
                        type: "product-group",
                        data: [
                            "foam-face-wash",
                            "gel-face-wash",
                            "cream-cleanser",
                            "micellar-water",
                            "oil-cleanser"
                        ]
                    },

                    {   //added recently
                        id: "beauty-tools",
                        name: "Beauty Tools",
                        type: "product-group",
                        data: [
                            "face-roller",
                            "ice-roller",
                            "gua-sha",
                            "blackhead-remover",
                            "facial-cleansing-brush",
                            "face-massager",
                            "eyebrow-razor",
                            "face-steamer",
                            "pore-vacuum",
                            "derma-roller",
                            "makeup-sponges",
                            "makeup-brush-set"
                        ]
                    },

                    {
                        id: "scrub-exfoliators",
                        name: "Scrub & Exfoliators",
                        type: "product-group",
                        data: [
                            "face-scrub",
                            "body-scrub",
                            "charcoal-scrub"
                        ]
                    },

                    {
                        id: "face-cream-toner-rose-water",
                        name: "Face Cream, Toner & Rose Water",
                        type: "product-group",
                        data: [
                            "moisturizer-cream",
                            "night-cream",
                            "face-toner",
                            "rose-water",
                            "essential-oils",
                            "aloe-vera-gel"
                        ]
                    },

                    {
                        id: "body-oil-lotion-moisturizer",
                        name: "Body Oil, Lotion & Moisturizer",
                        type: "product-group",
                        data: [
                            "body-lotion",
                            "body-butter",
                            "body-oil"
                        ]
                    },

                    {
                        id: "mens-grooming",
                        name: "Men's Grooming",
                        type: "product-group",
                        data: [
                            "shaving-cream",
                            "after-shave",
                            "beard-oil",
                            "beard-wash"
                        ]
                    },

                    {
                        id: "facial-kit-mask-wipes",
                        name: "Facial Kit, Mask & Wipes",
                        type: "product-group",
                        data: [
                            "facial-kit",
                            "sheet-mask",
                            "face-wipes",
                            "face-mask"
                        ]
                    },

                    {
                        id: "lip-care",
                        name: "Lip Care",
                        type: "product-group",
                        data: [
                            "lip-balm",
                            "tinted-lip-balm",
                            "lip-scrub"
                        ]
                    },

                    {
                        id: "sunscreen",
                        name: "Sunscreen",
                        type: "product-group",
                        data: [
                            "spf-30",
                            "spf-50",
                            "gel-sunscreen",
                            "sunscreen-stick",
                            "sunscreen-spray"
                        ]
                    },

                    {   // added recently
                        id: "makeup",
                        name: "Makeup",
                        type: "product-group",
                        data: [
                            "lipstick",
                            "foundation",
                            "mascara",
                            "eyeliner",
                            "eyeshadow",
                            "blush",
                            "compact-powder",
                            "makeup-remover",
                            "makeup-kits",
                            "nail-polish",
                            "kajal"
                        ]
                    },

                ]
            },
            {
                id: "hair-care",
                name: "Hair Care",
                type: "sub-category",
                data: [

                    {
                        id: "shampoo",
                        name: "Shampoo",
                        type: "product-group",
                        data: [
                            "anti-dandruff-shampoo",
                            "herbal-shampoo",
                            "protein-shampoo",
                            "baby-shampoo",
                            "anti-hairfall-shampoo",
                            "regular-shampoo"
                        ]
                    },

                    {
                        id: "hair-oil-serum",
                        name: "Hair Oil & Serum",
                        type: "product-group",
                        data: [
                            "coconut-oil",
                            "almond-oil",
                            "amla-oil",
                            "hair-serum",
                            "ayurvedic-hair-oil"
                        ]
                    },

                    {
                        id: "hair-colour-mehendi",
                        name: "Hair Colour & Mehendi",
                        type: "product-group",
                        data: [
                            "permanent-hair-colour",
                            "temporary-hair-colour",
                            "mehendi-powder",
                            "mehendi-cone"
                        ]
                    },

                    {
                        id: "conditioner",
                        name: "Conditioner",
                        type: "product-group",
                        data: [
                            "repair-conditioner",
                            "smoothening-conditioner",
                            "anti-hairfall-conditioner"
                        ]
                    },

                    {   // added recently
                        id: "hair-accessories",
                        name: "Hair Accessories",
                        type: "product-group",
                        data: [
                            "hair-brush",
                            "hair-comb",
                            "hair-bands",
                            "hair-clips",
                            "hair-ties"
                        ]
                    }

                ]
            },
            {
                id: "dental-care",
                name: "Dental Care",
                type: "sub-category",
                data: [

                    {
                        id: "toothpaste",
                        name: "Tooth Paste",
                        type: "product-group",
                        data: [
                            "herbal-toothpaste",
                            "whitening-toothpaste",
                            "sensitive-toothpaste",
                            "kids-toothpaste",
                            "regular-toothpaste"
                        ]
                    },

                    {
                        id: "toothbrush",
                        name: "Tooth Brush",
                        type: "product-group",
                        data: [
                            "soft-toothbrush",
                            "medium-toothbrush",
                            "electric-toothbrush"
                        ]
                    },

                    {
                        id: "mouthwash-oral-accessories",
                        name: "Mouth Wash & Oral Accessories",
                        type: "product-group",
                        data: [
                            "antiseptic-mouthwash",
                            "alcohol-free-mouthwash",
                            "dental-floss",
                            "toothbrush-holder"
                        ]
                    },

                    {
                        id: "kids-oral-care",
                        name: "Kids Oral Care",
                        type: "product-group",
                        data: [
                            "kids-toothbrush",
                            "kids-mouthwash"
                        ]
                    }

                ]
            },
            {
                id: "perfumes-talcum",
                name: "Perfumes & Talcum Powders",
                type: "sub-category",
                data: [

                    {
                        id: "deodorants",
                        name: "Deodorants",
                        type: "product-group",
                        data: [
                            "spray-deodorant",
                        ]
                    },

                    {
                        id: "perfumes",
                        name: "Perfumes",
                        type: "product-group",
                        data: [
                            "eau-de-parfum",
                            "eau-de-toilette",
                            "attar"
                        ]
                    },

                    {
                        id: "roll-on",
                        name: "Roll On",
                        type: "product-group",
                        data: [
                            "anti-perspirant-rollon"
                        ]
                    },

                    {
                        id: "talcum-powder",
                        name: "Talcum Powder",
                        type: "product-group",
                        data: [
                            "cooling-powder",
                            "herbal-talc"
                        ]
                    }

                ]
            },
            {
                id: "health-wellness",
                name: "Health & Wellness",
                type: "sub-category",
                data: [

                    {
                        id: "wound-care",
                        name: "Wound Care",
                        type: "product-group",
                        data: [
                            "bandage",
                            "antiseptic-liquid"
                        ]
                    },

                    {
                        id: "health-ayurveda",
                        name: "Health Ayurveda",
                        type: "product-group",
                        data: [
                            "chyawanprash",
                            "ayurvedic-tonic"
                        ]
                    },

                    {
                        id: "health-essentials",
                        name: "Health Essentials",
                        type: "product-group",
                        data: [
                            "thermometer",
                            "glucose-powder",
                            "medical-accessories"
                        ]
                    },

                    {
                        id: "pain-relief",
                        name: "Pain Relief",
                        type: "product-group",
                        data: [
                            "pain-relief-spray",
                            "pain-relief-balm"
                        ]
                    }

                ]
            },
            {
                id: "baby-care",
                name: "Baby Care",
                type: "sub-category",
                data: [

                    {
                        id: "baby-food",
                        name: "Baby Food",
                        type: "product-group",
                        data: [
                            "infant-formula",
                            "baby-cereal"
                        ]
                    },

                    {
                        id: "baby-shampoo-soaps",
                        name: "Shampoo & Soaps",
                        type: "product-group",
                        data: [
                            "baby-soap",
                            "tear-free-shampoo"
                        ]
                    },

                    {
                        id: "diapers-wipes",
                        name: "Diapers & Wipes",
                        type: "product-group",
                        data: [
                            "newborn-diapers",
                            "baby-wipes"
                        ]
                    },

                    {
                        id: "baby-oil-cream-powder",
                        name: "Oil, Cream & Powder",
                        type: "product-group",
                        data: [
                            "baby-oil",
                            "baby-lotion",
                            "baby-powder"
                        ]
                    },

                    {
                        id: "baby-health-tooth-care",
                        name: "Baby Health & Tooth Care",
                        type: "product-group",
                        data: [
                            "baby-thermometer",
                            "baby-toothbrush"
                        ]
                    },

                    {
                        id: "baby-accessories",
                        name: "Baby Accessories",
                        type: "product-group",
                        data: [
                            "feeding-bottle",
                            "pacifier"
                        ]
                    }

                ]
            },
            {
                id: "feminine-hygiene",
                name: "Feminine Hygiene",
                type: "sub-category",
                data: [

                    {
                        id: "sanitary-pad",
                        name: "Sanitary Pad",
                        type: "product-group",
                        data: [
                            "regular-pad",
                            "xl-pad",
                            "overnight-pad"
                        ]
                    },

                    {
                        id: "hair-removal",
                        name: "Hair Removal",
                        type: "product-group",
                        data: [
                            "hair-removal-cream",
                            "wax-strips",
                            "razor"
                        ]
                    }

                ]
            },
            {   // added recently
                id: "personal-hygiene",
                name: "Personal Hygiene",
                type: "sub-category",
                data: [
                    {
                        id: "hygiene-tools",
                        name: "Hygiene Tools",
                        type: "product-group",
                        data: [
                            "ear-cleaning-tool",
                            "nail-cutter"
                        ]
                    }
                ]
            }
        ]
    },
    {
        id: 'household-essentials',
        name: 'Household Essentials',
        type: 'category',
        data: [
            {
                id: "cleaning-essentials",
                name: "Cleaning Essentials",
                type: "sub-category",
                data: [

                    {
                        id: "repellents-disinfection",
                        name: "Repellents & Disinfections",
                        type: "product-group",
                        data: [
                            "mosquito-repellent-liquid",
                            "mosquito-coil",
                            "mosquito-repellent-spray",
                            "cockroach-killer-spray",
                            "insect-killer-spray",
                            "rat-killer",
                            "surface-disinfectant",
                            "bleaching-powder",
                            "disinfectant-liquid"
                        ]
                    },

                    {
                        id: "glass-metal-cleaners",
                        name: "Glass, Metal Cleaners",
                        type: "product-group",
                        data: [
                            "glass-cleaner-spray",
                            "metal-polish",
                            "steel-cleaner"
                        ]
                    },

                    {
                        id: "detergent-powder-bars",
                        name: "Detergent Powder & Bars",
                        type: "product-group",
                        data: [
                            "washing-powder",
                            "detergent-bar",
                            "fabric-whitener",
                            "detergent-powder"
                        ]
                    },

                    {
                        id: "toilet-floor-cleaners",
                        name: "Toilet & Floor Cleaners",
                        type: "product-group",
                        data: [
                            "toilet-cleaner",
                            "floor-cleaner",
                            "phenyl"
                        ]
                    },

                    {
                        id: "cleaning-tools",
                        name: "Cleaning Tools",
                        type: "product-group",
                        data: [
                            "broom",
                            "mop",
                            "wiper",
                            "scrub-pad",
                            "lint-remover",
                            "dusters",
                            "bathroom-mugs",
                            "scrub-brush",
                            "bottle-cleaning-brush"
                        ]
                    },

                    {
                        id: "dishwash-bars",
                        name: "Dishwash & Bars",
                        type: "product-group",
                        data: [
                            "dishwash-bar",
                            "dishwash-liquid"
                        ]
                    },

                    {
                        id: "liquid-detergents",
                        name: "Liquid Detergents",
                        type: "product-group",
                        data: [
                            "front-load-liquid",
                            "top-load-liquid"
                        ]
                    },

                    {
                        id: "shoe-care",
                        name: "Shoe Care",
                        type: "product-group",
                        data: [
                            "shoe-polish",
                            "shoe-brush"
                        ]
                    },

                    {
                        id: "fresheners",
                        name: "Fresheners",
                        type: "product-group",
                        data: [
                            "room-freshener-spray",
                            "gel-freshener",
                            "air-freshener-block"
                        ]
                    },

                    {
                        id: "machine-car-care",
                        name: "Machine & Car Care",
                        type: "product-group",
                        data: [
                            "washing-machine-cleaner",
                            "car-shampoo",
                            "car-accessories"
                        ]
                    }

                ]
            },
            {
                id: "home-lifestyles",
                name: "Home & Lifestyles",
                type: "sub-category",
                data: [

                    {
                        id: "home-decor",
                        name: "Home Decor",
                        type: "product-group",
                        data: [
                            "wall-art",
                            "showpiece",
                            "photo-frame"
                        ]
                    },

                    {
                        id: "plants-bouquets",
                        name: "Plants & Bouquets",
                        type: "product-group",
                        data: [
                            "indoor-plant",
                            "artificial-plant",
                            "flower-bouquet"
                        ]
                    },

                    {
                        id: "bedsheets-towels",
                        name: "Bedsheets & Towels",
                        type: "product-group",
                        data: [
                            "single-bedsheet",
                            "double-bedsheet",
                            "bath-towel",
                            "hand-towel"
                        ]
                    },

                    {
                        id: "gardening",
                        name: "Gardening",
                        type: "product-group",
                        data: [
                            "garden-tools",
                            "flower-seeds",
                            "plant-pot"
                        ]
                    },

                    {
                        id: "decorative-lights",
                        name: "Decorative Lights",
                        type: "product-group",
                        data: [
                            "fairy-lights",
                            "led-strip-light",
                            "festival-lights"
                        ]
                    },

                    {
                        id: "home-needs",
                        name: "Home Needs",
                        type: "product-group",
                        data: [
                            "cloth-hanger",
                            "storage-box",
                            "laundry-basket",
                            "rope",
                            "door-window-accessories",
                            "wall-hooks",
                            "repair-accessories",
                            "locks"
                        ]
                    },

                    {
                        id: "tissues-disposables",
                        name: "Tissues & Disposables",
                        type: "product-group",
                        data: [
                            "facial-tissue",
                            "kitchen-towel-roll",
                            "paper-napkin",
                            "paper-cups",
                            "paper-straws"
                        ]
                    },

                    {
                        id: "jewellery",
                        name: "Jewellery",
                        type: "product-group",
                        data: [
                            "necklace",
                            "earrings",
                            "bracelet"
                        ]
                    },

                    {
                        id: "innerwear",
                        name: "Innerwear",
                        type: "product-group",
                        data: [
                            "mens-innerwear",
                            "womens-innerwear",
                            "kids-innerwear"
                        ]
                    },

                    {
                        id: "lifestyle-accessories",
                        name: "Lifestyle Accessories",
                        type: "product-group",
                        data: [
                            "wallet",
                            "belt",
                            "sunglasses",
                            "key-accessories"
                        ]
                    },

                    {
                        id: "party-festive-needs",
                        name: "Party & Festive Needs",
                        type: "product-group",
                        data: [
                            "birthday-decor",
                            "festival-decor",
                            "balloons",
                            "party-popper"
                        ]
                    },

                    {
                        id: "socks-handkerchiefs",
                        name: "Socks & Handkerchiefs",
                        type: "product-group",
                        data: [
                            "mens-socks",
                            "womens-socks",
                            "handkerchief"
                        ]
                    },

                    {
                        id: "fresheners-home",
                        name: "Fresheners",
                        type: "product-group",
                        data: [
                            "room-spray",
                            "gel-freshener-home",
                            "automatic-diffuser"
                        ]
                    },

                    {
                        id: "pooja-needs",
                        name: "Pooja Needs",
                        type: "product-group",
                        data: [
                            "agarbatti",
                            "dhoop",
                            "camphor",
                            "diya",
                            "electric-diya",
                            "cotton-wicks",
                            "pooja-oil",
                            "ghee-for-diya",
                            "roli",
                            "chawal",
                            "moli-kalava",
                            "kumkum",
                            "haldi",
                            "durva-grass",
                            "coconut-pooja",
                            "pooja-thali",
                            "kalash",
                            "pooja-bell",
                            "havan-samagri",
                            "havan-kund",
                            "flower-garland",
                            "pooja-leaves",
                            "ganga-jal"
                        ]
                    },

                    {
                        id: "bathroom-essentials",
                        name: "Bathroom Essentials",
                        type: "product-group",
                        data: [
                            "soap-dispenser",
                            "toothbrush-holder",
                            "shower-curtain"
                        ]
                    },

                    {
                        id: "bags",
                        name: "Bags",
                        type: "product-group",
                        data: [
                            "travel-bag",
                            "school-bag",
                            "handbag",
                            "utility-bags",
                            "shoe-bags"
                        ]
                    }

                ]
            },
            {
                id: "electronics",
                name: "Electronics",
                type: "sub-category",
                data: [
                    {
                        id: "trimmers-hair-appliances",
                        name: "Trimmers & Hair Appliances",
                        type: "product-group",
                        data: [
                            "beard-trimmer",
                            "hair-trimmer",
                            "hair-dryer",
                            "hair-straightener",
                            "hair-curler"
                        ]
                    },
                    {
                        id: "earphones-headsets",
                        name: "Earphones & Headsets",
                        type: "product-group",
                        data: [
                            "wired-earphones",
                            "bluetooth-earbuds",
                            "neckband-earphones",
                            "gaming-headset"
                        ]
                    },
                    {
                        id: "speakers",
                        name: "Speakers",
                        type: "product-group",
                        data: [
                            "bluetooth-speaker",
                            "party-speaker",
                            "home-theatre"
                        ]
                    },
                    {
                        id: "mobile-computer",
                        name: "Mobile & Computer",
                        type: "product-group",
                        data: [
                            "smartphone",
                            "feature-phone",
                            "laptop",
                            "keyboard",
                            "mouse",
                            "mobile-stand",
                            "mobile-holder",
                            "writing-tablet",
                            "portable-fan",
                            "keyboard-accessories",
                            "cleaning-accessories",
                            "mouse-accessories",
                            "gaming-accessories",
                            "mobile-accessories",
                            "cable-accessories"
                        ]
                    },
                    {
                        id: "decorative-lights-electronics",
                        name: "Decorative Lights",
                        type: "product-group",
                        data: [
                            "led-bulb",
                            "smart-led-strip",
                            "string-lights"
                        ]
                    },
                    {
                        id: "chargers-cables",
                        name: "Chargers & Cables",
                        type: "product-group",
                        data: [
                            "mobile-charger",
                            "fast-charger",
                            "usb-cable",
                            "type-c-cable",
                            "hdmi-cable",
                            "otg-cable"
                        ]
                    },
                    {
                        id: "smart-watches",
                        name: "Smart Watches",
                        type: "product-group",
                        data: [
                            "fitness-band",
                            "bluetooth-calling-watch",
                            "kids-smartwatch"
                        ]
                    },
                    {
                        id: "kitchen-appliances",
                        name: "Kitchen Appliances",
                        type: "product-group",
                        data: [
                            "mixer-grinder",
                            "electric-kettle",
                            "induction-cooktop",
                            "microwave-oven"
                        ]
                    },
                    {
                        id: "batteries",
                        name: "Batteries",
                        type: "product-group",
                        data: [
                            "aa-battery",
                            "aaa-battery",
                            "rechargeable-battery"
                        ]
                    },
                    {
                        id: "extension-cables-accessories",
                        name: "Extension Cables & Accessories",
                        type: "product-group",
                        data: [
                            "extension-board",
                            "spike-guard",
                            "power-strip"
                        ]
                    },
                    {
                        id: "home-appliances",
                        name: "Home Appliances",
                        type: "product-group",
                        data: [
                            "iron",
                            "room-heater",
                            "ceiling-fan",
                            "air-cooler",
                            "massager"
                        ]
                    },
                    {
                        id: "music-instruments-accessories",
                        name: "Music Instruments & Accessories",
                        type: "product-group",
                        data: [
                            "guitar",
                            "keyboard-instrument",
                            "tabla",
                            "guitar-strings"
                        ]
                    }

                ]
            },
            {
                id: "stationary-games",
                name: "Stationary & Games",
                type: "sub-category",
                data: [

                    {
                        id: "notebooks-diaries",
                        name: "Notebooks & Diaries",
                        type: "product-group",
                        data: [
                            "ruled-notebook",
                            "plain-notebook",
                            "spiral-notebook",
                            "personal-diary",
                        ]
                    },

                    {
                        id: "pens-pencils",
                        name: "Pens & Pencils",
                        type: "product-group",
                        data: [
                            "ball-pen",
                            "gel-pen",
                            "ink-pen",
                            "pencil",
                            "mechanical-pencil",
                            "highlighter",
                            "marker-pen",
                            "eraser",
                            "sharpener",
                        ]
                    },

                    {
                        id: "toys-games",
                        name: "Toys & Games",
                        type: "product-group",
                        data: [
                            "board-game",
                            "remote-control-toy",
                            "puzzle-game",
                            "educational-toy",
                            "action-figure",
                            "stress-ball",
                            "card-game",
                        ]
                    },

                    {
                        id: "glue-tape",
                        name: "Glue & Tape",
                        type: "product-group",
                        data: [
                            "white-glue",
                            "fevicol",
                            "cellotape",
                            "double-sided-tape",
                            "glue-stick",
                            "instant-glue",
                        ]
                    },

                    {
                        id: "books-magazines",
                        name: "Books & Magazines",
                        type: "product-group",
                        data: [
                            "novel",
                            "competitive-exam-book",
                            "monthly-magazine",
                            "reading-accessories",
                        ]
                    },

                    {
                        id: "school-needs",
                        name: "School Needs",
                        type: "product-group",
                        data: [
                            "geometry-box",
                            "school-bottle",
                            "lunch-box-school",
                            "geometry-tools",
                        ]
                    },

                    {
                        id: "childrens-book",
                        name: "Children's Book",
                        type: "product-group",
                        data: [
                            "story-book",
                            "coloring-book",
                            "activity-book",
                        ]
                    },

                    {
                        id: "art-crafts",
                        name: "Art & Crafts",
                        type: "product-group",
                        data: [
                            "crayons",
                            "water-colors",
                            "sketch-pen",
                            "craft-paper",
                            "color-pencils",
                            "paint-brushes",
                            "drawing-books",
                            "crochet-hook",
                            "knitting-needle",
                            "yarn",
                        ]
                    },

                    {
                        id: "files-office-needs",
                        name: "Files & Office Needs",
                        type: "product-group",
                        data: [
                            "office-file",
                            "clipboard",
                            "stapler",
                            "paper-punch",
                            "sticky-notes",
                            "stick-file",
                            "magnifying-glasses",
                        ]
                    },

                    {
                        id: "gift-wraps-bags",
                        name: "Gift Wraps & Bags",
                        type: "product-group",
                        data: [
                            "gift-wrapper",
                            "gift-bag",
                            "ribbon",
                        ]
                    },

                    {
                        id: "sports-gym",
                        name: "Sports & Gym",
                        type: "product-group",
                        data: [
                            "cricket-bat",
                            "football",
                            "badminton-racket",
                            "yoga-mat",
                            "dumbbells",
                            "hand-grip",
                        ]
                    }

                ]
            },
            {
                id: "kitchen-dining",
                name: "Kitchen & Dining",
                type: "sub-category",
                data: [

                    {
                        id: "pressure-cooker",
                        name: "Pressure Cooker",
                        type: "product-group",
                        data: [
                            "aluminium-pressure-cooker",
                            "stainless-steel-pressure-cooker",
                            "induction-pressure-cooker",
                            "mini-pressure-cooker",
                        ]
                    },

                    {
                        id: "cookware-set",
                        name: "Cookware Set",
                        type: "product-group",
                        data: [
                            "nonstick-cookware",
                            "stainless-cookware",
                            "hard-anodized-set",
                            "cast-iron-set",
                        ]
                    },

                    {
                        id: "bottles-flask",
                        name: "Bottles & Flask",
                        type: "product-group",
                        data: [
                            "steel-water-bottle",
                            "plastic-water-bottle",
                            "thermos-flask",
                            "insulated-bottle",
                            "clay-bottle",
                            "glass-bottle",
                        ]
                    },

                    {
                        id: "gas-stove-accessories",
                        name: "Gas Stove & Accessories",
                        type: "product-group",
                        data: [
                            "2-burner-gas-stove",
                            "3-burner-gas-stove",
                            "gas-lighter",
                            "gas-pipe-regulator",
                        ]
                    },

                    {
                        id: "kitchen-aids",
                        name: "Kitchen Aids",
                        type: "product-group",
                        data: [
                            "vegetable-chopper",
                            "hand-blender",
                            "grater-peeler",
                            "kitchen-scissors",
                            "hand-chopper",
                        ]
                    },

                    {
                        id: "kitchen-storage",
                        name: "Kitchen Storage",
                        type: "product-group",
                        data: [
                            "storage-container",
                            "masala-box",
                            "grain-storage-drum",
                            "oil-dispenser",
                        ]
                    },

                    {
                        id: "tableware-more",
                        name: "Tableware & More",
                        type: "product-group",
                        data: [
                            "dinner-set",
                            "serving-bowl",
                            "plates",
                            "cutlery-set",
                        ]
                    },

                    {
                        id: "steel-utensils",
                        name: "Steel Utensils",
                        type: "product-group",
                        data: [
                            "steel-plate",
                            "steel-glass",
                            "steel-kadhai",
                            "steel-pan",
                            "steel-mugs-cups",
                        ]
                    },

                    {
                        id: "lunch-boxes",
                        name: "Lunch Boxes",
                        type: "product-group",
                        data: [
                            "steel-lunch-box",
                            "plastic-lunch-box",
                            "insulated-lunch-box",
                        ]
                    },

                    {
                        id: "kitchen-tools",
                        name: "Kitchen Tools",
                        type: "product-group",
                        data: [
                            "knife-set",
                            "rolling-pin",
                            "tongs",
                            "ladle-spoon",
                            "measuring-tools",
                        ]
                    },

                    {
                        id: "drinkware-bar",
                        name: "Drinkware & Bar",
                        type: "product-group",
                        data: [
                            "wine-glass",
                            "beer-mug",
                            "cocktail-shaker",
                            "bar-accessories",
                            "coffee-mug",
                            "glass-cup",
                            "tea-cup",
                            "water-glass",
                        ]
                    },

                    {
                        id: "kitchen-essentials",
                        name: "Kitchen Essentials",
                        type: "product-group",
                        data: [
                            "aluminium-foil",
                            "cling-film",
                            "butter-paper",
                            "zip-lock-bag",
                            "garbage-bag",
                            "toothpicks",
                        ]
                    }

                ]
            },
            {
                id: "pet-care",
                name: "Pet Care",
                type: "sub-category",
                data: [

                    {
                        id: "cat-food",
                        name: "Cat Food",
                        type: "product-group",
                        data: [
                            "dry-cat-food",
                            "wet-cat-food",
                            "kitten-food",
                            "grain-free-cat-food",
                        ]
                    },

                    {
                        id: "dog-food",
                        name: "Dog Food",
                        type: "product-group",
                        data: [
                            "dry-dog-food",
                            "wet-dog-food",
                            "puppy-food",
                            "grain-free-dog-food",
                            "breed-specific-dog-food",
                        ]
                    },

                    {
                        id: "pet-treat-toys",
                        name: "Pet Treat & Toys",
                        type: "product-group",
                        data: [
                            "dog-treats",
                            "cat-treats",
                            "chew-toys",
                            "rope-toys",
                            "interactive-toys",
                        ]
                    },

                    {
                        id: "pet-grooming",
                        name: "Pet Groomings",
                        type: "product-group",
                        data: [
                            "pet-shampoo",
                            "tick-flea-treatment",
                            "pet-brush-comb",
                            "nail-clipper",
                            "pet-perfume",
                        ]
                    }

                ]
            }
        ]
    }
]